import { FC } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { PREPAID_CARDS_NOT_IMPLEMENTED } from "../../constants/prepaidCards";

/**
 * SIMS-8948 — prepaid card orders.
 *
 * This page used to list and create card orders through backend-1
 * (`cards/orders`, `cards/order`, `beneficiaries/{id}/cards`). Those calls are
 * gone so backend-1 can be decommissioned (epic SIMS-6473); PPC was never
 * finished or tested, and if it is picked up again it will be rebuilt on
 * backend-2.
 *
 * The route is kept rather than removed so the link does not 404, and so the
 * state is stated plainly instead of showing a permanently empty table — the
 * same choice made in PR #1348, which named the setting to change rather than
 * failing silently.
 */
const CardsList: FC = () => {
	return (
		<Box sx={{ p: 3 }}>
			<Typography variant="h5" component="h1" gutterBottom>
				Cards
			</Typography>
			<Card>
				<CardContent>
					<Typography variant="body1">
						{PREPAID_CARDS_NOT_IMPLEMENTED}
					</Typography>
					<Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
						Card ordering and prepaid card management are not available in this
						version.
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
};

export default CardsList;
